<template>
  <div>
    <v-row style="width: 60vw" no-gutters>
      <v-col cols="5">
        <vue-auto-complete
          :endpoint="
            `/api/v1/crm/clients/select/?organization__slug=${this.$store.state.shell.currentOrganizationId}`
          "
          placeholder="Search Client by Name or Email and press Enter"
          dense
          filled
          background-color="grey darken-1"
          light
          hide-details
          load-at-enter-only
          class="pt-1"
          item-text="name"
          item-value="slug"
          @input="redirectToClientPage($event)"
        ></vue-auto-complete>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="auto">
        <v-tooltip bottom>
          <template v-slot:activator="{ on }">
            <v-chip small color="teal" class="mx-1 abbChip" v-on="on">
              {{
                $store.state.shell.currentOrganizationName
                  ? $store.state.shell.currentOrganizationName
                      .substring(0, 3)
                      .toUpperCase()
                  : ""
              }}
            </v-chip>
          </template>
          {{ $store.state.shell.currentOrganizationName }}
        </v-tooltip>
        <v-tooltip bottom>
          <template v-slot:activator="{ on }" class="mx-1">
            <v-badge
              :value="getUnreadNotificationCount"
              :content="getUnreadNotificationCount"
              offset-x="20"
              color="red"
              overlap
            >
              <v-icon
                v-if="getUnreadNotificationCount"
                size="22"
                class="mx-1"
                @click.stop="rightDrawer = !rightDrawer"
                v-on="on"
                v-text="$getIcon('mdiBell')"
              ></v-icon>
              <v-icon
                v-else
                size="22"
                class="mx-1"
                @click.stop="rightDrawer = !rightDrawer"
                v-on="on"
                v-text="$getIcon('mdiBellOff')"
              ></v-icon>
            </v-badge>
          </template>
          <span
            v-text="
              getUnreadNotificationCount
                ? `${getUnreadNotificationCount} Notifications`
                : 'No Notifications'
            "
          ></span>
        </v-tooltip>
        <v-navigation-drawer
          v-model="rightDrawer"
          width="350"
          fixed
          right
          height="100vh"
          temporary
          absolute
        >
          <vue-notification-bar
            v-if="rightDrawer"
            @closeDrawer="rightDrawer = false"
            @refreshNotification="getUnreadNotificationCount = $event"
          >
          </vue-notification-bar>
        </v-navigation-drawer>
        <v-menu left bottom>
          <template v-slot:activator="{ on }">
            <v-btn icon v-on="on">
              <v-icon v-text="$getIcon('mdiDotsVertical')"></v-icon>
            </v-btn>
          </template>
          <v-list>
            <v-list-item @click="openSwitchOrganizationList = true">
              <v-list-item-icon>
                <v-icon
                  size="20"
                  v-text="$getIcon('mdiAccountSwitch')"
                ></v-icon>
              </v-list-item-icon>
              <v-list-item-title>Switch Organization</v-list-item-title>
            </v-list-item>
            <v-list-item @click="$router.push({ name: 'logout' })">
              <v-list-item-icon>
                <v-icon
                  size="20"
                  v-text="$getIcon('mdiLogoutVariant')"
                ></v-icon>
              </v-list-item-icon>
              <v-list-item-title>Logout</v-list-item-title>
            </v-list-item>
          </v-list>
        </v-menu>
        <switch-organization
          v-if="openSwitchOrganizationList"
          :dialog="openSwitchOrganizationList"
          @close="openSwitchOrganizationList = false"
        ></switch-organization>
      </v-col>
    </v-row>
  </div>
</template>
<script>
import SwitchOrganization from "@/components/common/layout_utils/SwitchOrganization";
import VueNotificationBar from "@/components/common/layout_utils/VueNotificationBar";
import VueAutoComplete from "@/components/common/form_utils/updatedVueAutoComplete";
export default {
  components: { SwitchOrganization, VueNotificationBar, VueAutoComplete },
  data() {
    return {
      openSwitchOrganizationList: false,
      rightDrawer: false,
      getUnreadNotificationCount: 0
    };
  },
  created() {
    this.getNotificationCount();
    window.setInterval(() => {
      this.getNotificationCount();
    }, 3000000);
  },
  methods: {
    redirectToClientPage(slug) {
      if (slug) {
        this.$router.push({
          name: "clients-clientslug",
          params: {
            clientSlug: slug
          },
          query: {
            tab: "communication-log"
          }
        });
      }
    },
    getNotificationCount() {
      const endpoint = "/api/v1/notification/stats";
      this.$axios.$get(endpoint).then(response => {
        this.getUnreadNotificationCount = response.unread_count;
      });
    }
  }
};
</script>
